// Formattazione date in standard italiano dd/mm/yyyy [HH:MM].
// I timestamp assoluti (con offset/Z) sono mostrati sempre in orario di Roma (Europe/Rome).
export function formatDateTime(value) {
  if (!value) return "";
  const s = String(value).trim().replace(" ", "T");
  const d = new Date(s);
  if (isNaN(d.getTime())) return String(value);
  const hasOffset = /([zZ]|[+-]\d{2}:?\d{2})$/.test(s);
  const hasTime = /T\d{1,2}:\d{2}/.test(s) || /\b\d{1,2}:\d{2}/.test(s);
  if (hasOffset) {
    const fmt = new Intl.DateTimeFormat("it-IT", {
      timeZone: "Europe/Rome",
      day: "2-digit", month: "2-digit", year: "numeric",
      ...(hasTime ? { hour: "2-digit", minute: "2-digit", hour12: false } : {}),
    });
    return fmt.format(d).replace(",", "");
  }
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return hasTime ? `${dd}/${mm}/${yy} ${hh}:${mi}` : `${dd}/${mm}/${yy}`;
}

// Età in anni compiuti da una data di nascita (gg/mm/aaaa, gg-mm-aaaa o aaaa-mm-gg). "" se non valida.
export function ageFromBirthDate(value) {
  if (!value) return "";
  const s = String(value).trim();
  let d, m, y;
  let mt = s.match(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})$/);
  if (mt) [, d, m, y] = mt;
  else if ((mt = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/))) [, y, m, d] = mt;
  else return "";
  const birth = new Date(Number(y), Number(m) - 1, Number(d));
  if (isNaN(birth.getTime()) || birth.getMonth() !== Number(m) - 1) return "";
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  if (now.getMonth() < birth.getMonth() || (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate())) age -= 1;
  return age >= 0 && age < 130 ? String(age) : "";
}
